import { ptBR } from '@/i18n/pt-BR';
import type { AmbienteAdmin } from '@/lib/plataforma_admin';

const _AMBIENTES: Record<AmbienteAdmin, string> = {
  plataforma: ptBR.admin.ambientePlataforma,
  escritorio: ptBR.admin.ambienteEscritorio,
  banco: ptBR.admin.ambienteBanco,
};

/**
 * Ambiente → frase, no vocabulário do CONSOLE (onde um banco se chama // ux-neutrality:allow doc-comment
 * "Cliente"). Ficou aqui, e não no catálogo compartilhado da trilha, porque a // ux-neutrality:allow doc-comment
 * tela do banco não mostra a coluna Ambiente e não fala esse dialeto. // ux-neutrality:allow doc-comment
 */
export function ambienteLabel(ambiente: AmbienteAdmin): string {
  return _AMBIENTES[ambiente];
}
